









































































import PageLayout from '../layouts/PageLayout.vue';
import DetailsBox from '../subComponents/DetailsBox/DetailsBox.vue';
import LoadingBox from '../LoadingBox/LoadingBox.vue';
import { getCustomerProfile, ICustomerProfile } from '../../api/index';
import { apiErrorHelper } from '../../api/apiErrorHelper';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'ProfileDetails',
  components: {
    PageLayout,
    DetailsBox,
    ScText: Text,
    ScRichText: RichText,
    LoadingBox,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      profile: null as ICustomerProfile, //how to see the properties in vue template???,
      loading: true,
    };
  },
  async mounted() {
    try {
      this.profile = await getCustomerProfile();
      this.loading = false;
    } catch (error) {
      apiErrorHelper(this.$router, error);
      this.loading = false;
    }
  },
};
